import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {ValidatorFn, UntypedFormGroup} from '@angular/forms';
import * as MOMENT from 'moment-timezone';
@Injectable({
  providedIn: 'root'
})

export class CommonService {
  showsuccessMessage = false;
  public eventEmitter = new Subject<any>();
  public dataSourceEmitter = new Subject<any>();
  public entityRecong = new Subject<any>();
  public entityAutoComplete = new Subject<any>();
  public companyNameWithId = new Subject<any>();
  public clearAutoComplete = new Subject<any>();
  public companyNameChange = new Subject<any>();
  public autocompleteItems = new Subject<any>();
  public companyNameFocus = new Subject<any>();
  constructor() { }

  eventTypeCatch() {
    return this.eventEmitter.asObservable();
  }
  eventType(payload: any) {
    this.eventEmitter.next(payload);
  }
  dataSourceCatch() {
    return this.dataSourceEmitter.asObservable();
  }
  dataSource(url: any) {
    this.dataSourceEmitter.next(url);
  }
  entityRecongCatch() {
    return this.entityRecong.asObservable();
  }
  entityRecongEmit(payload: any) {
    this.entityRecong.next(payload);
  }
  companyNameWithIdCatch() {
    return this.companyNameWithId.asObservable();
  }
  emitCompanyNameWithId(payload: any) {
    this.companyNameWithId.next(payload);
  }
  emitClearAutoComplete(payload) {
    this.clearAutoComplete.next(payload);
  }
  clearAutoCompleteCatch () {
    return this.clearAutoComplete.asObservable();
  }
  catchCompanyNameChange() {
    return this.companyNameChange.asObservable();
  }
  emitCompanyNameChange(payload) {
    this.companyNameChange.next(payload);
  }
  catchAutocompleteItems() {
    return this.autocompleteItems.asObservable()
  }
  emitAutocompleteItems(values: any) {
    this.autocompleteItems.next(values)
  } 
  catchClearEntityAutoComplete() {
    return this.entityAutoComplete.asObservable()
  }
  emitClearEntityAutoComplete(value: boolean) {
    this.entityAutoComplete.next(value)
  } 
  validateDate(startDate: string,endDate: string) :ValidatorFn {
    return (form:UntypedFormGroup): { [key: string]: any } | null => {
      if(form.get(startDate).value && form.get(endDate).value && MOMENT(form.get(startDate).value, 'YYYY-MM-DD', true).isValid() && MOMENT(form.get(endDate).value, 'YYYY-MM-DD', true).isValid()) {
        const firstDate = new Date(form.get(startDate).value);
        const secondDate = new Date(form.get(endDate).value);
        if (firstDate.getTime() >= secondDate.getTime()) {
          form.get(endDate).setErrors({ error: `${endDate} should be greater than the ${startDate}.` })
          return ;
        } else {
            form.get(endDate).setErrors(null);
            return;
        }
      }
    };
  }
  validateDateRequired(startDate: string,endDate: string) :ValidatorFn {
    return (form:UntypedFormGroup): { [key: string]: any } | null => {
      if(form.get(startDate).value && form.get(endDate).value && MOMENT(form.get(startDate).value, 'YYYY-MM-DD', true).isValid() && MOMENT(form.get(endDate).value, 'YYYY-MM-DD', true).isValid()) {
        const firstDate = new Date(form.get(startDate).value);
        const secondDate = new Date(form.get(endDate).value);
        if (firstDate.getTime() > secondDate.getTime()) {
          form.get(endDate).setErrors({ error: `${endDate} should be greater than the ${startDate}.` })
          return ;
        } else {
            form.get(endDate).setErrors(null);
            return;
        }
      }else if(form.get(startDate).value && !form.get(endDate).value ){
        form.get(endDate).setErrors({ error: `Requied Valid End Date` })
      }
      else if(!form.get(startDate).value && form.get(endDate).value ){
        form.get(endDate).setErrors({ error: `Requied Valid Start Date` })
      }else if(!form.get(startDate).value && !form.get(endDate).value ){
        form.get(endDate).setErrors(null);
        return;
      }
    };
  }
  validateMatch(firstMatch: string,secondMatch: string,firstMatchName: string, secondMatchName: string ) :ValidatorFn {
    return (form:UntypedFormGroup): { [key: string]: any } | null => {
      if (form.get(firstMatch).value && form.get(secondMatch).value && form.get(firstMatchName).value && form.get(secondMatchName).value)  {
        if ( (form.get(firstMatch).value == form.get(secondMatch).value) ||  (form.get(firstMatchName).value == form.get(secondMatchName).value)) {
          form.get(secondMatch).setErrors({ error: 'Acquirer and Target Company cannot be same.' })
          return ;
        }
      }
    };
  }
  findDuplicate(arr,key1,key2, fromEvents = false) {
    console.log(key1,key2);
    var _unArray = [];
    var _duplicateArray = [];
    arr.forEach(function(item) {
        var isPresent = _unArray.filter(function(elem) {
          if(key1 && key2 && elem[key1] && item[key1] && elem[key2] && item[key2])
            return elem[key1].toString().toUpperCase() === item[key1].toString().toUpperCase() && elem[key2].toString().toUpperCase() === item[key2].toString().toUpperCase()
          if(key1 && elem[key1] && item[key1] )
            if(fromEvents) return MOMENT(elem[key1]).format('YYYY-MM-DD') === MOMENT(item[key1]).format('YYYY-MM-DD');
            else return elem[key1].toString().toUpperCase() === item[key1].toString().toUpperCase()
        })
        if (isPresent.length == 0) {
            _unArray.push(item)
        } else {
            _duplicateArray.push(item)
        }
    })
    if(_duplicateArray.length) return {isInValid: true, error : {message: [`Duplicate ticker and exchange present.`]}};
    return {isInValid: false }
    
  }
  
  duplicateEvents(allEvents: any,event: any,key1: string='',key2: string ='', checkdate: boolean = false) {
    let duplicates = [];
    allEvents.forEach( (element: any) => {
      if(key1 && key2 && element[key1] && element[key2] && event[key1] && event[key2] ) {
        if(element[key1].toString().toUpperCase() === event[key1].toString().toUpperCase() && element[key2].toString().toUpperCase() === event[key2].toString().toUpperCase()) duplicates.push(element);
      } else if(key1 && element[key1] && event[key1]) {
        if(checkdate) {
          if(MOMENT(element[key1]).format('YYYY-MM-DD') === MOMENT(event[key1]).format('YYYY-MM-DD')) duplicates.push(element);
        } else if(element[key1].toString().toUpperCase() === event[key1].toString().toUpperCase()) duplicates.push(element);
      }
    });
    if(duplicates.length) return {isInValid: true, duplicates: duplicates};
    return {isInValid: false};
  }

  getCompanyNameFocus() {
    this.companyNameFocus.next();
  }
  
  catchCompanyNameFocus() {
    return this.companyNameFocus.asObservable();
  }

}
